var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", "no-margin": "" } },
    [
      _vm._l(_vm.filter.Values, function (val, i) {
        return _c(
          "w-row",
          { key: i },
          [
            _c(
              "w-col",
              { attrs: { xs: "12" } },
              [
                _c("w-input", {
                  attrs: { fancy: "", label: _vm.$ct("label") },
                  model: {
                    value: _vm.filter.Labels[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.filter.Labels, i, $$v)
                    },
                    expression: "filter.Labels[i]",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-col",
              { attrs: { xs: "12" } },
              [
                _c(
                  "w-row",
                  [
                    _c("app-filter-input", {
                      style: { flexGrow: 1 },
                      attrs: {
                        "field-type": _vm.fieldType,
                        label:
                          _vm.filter.Values.length == 1
                            ? _vm.$ct("single-value")
                            : _vm.$ct("value", { val: i + 1 }),
                      },
                      model: {
                        value: _vm.filter.Values[i],
                        callback: function ($$v) {
                          _vm.$set(_vm.filter.Values, i, $$v)
                        },
                        expression: "filter.Values[i]",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "align-bottom" },
                      [
                        _vm.valueAmount == -1
                          ? _c(
                              "w-button",
                              {
                                attrs: { flat: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeValue(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "times" } })],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-row",
        [
          _vm.valueAmount == -1
            ? _c(
                "w-col",
                { attrs: { xs: "6", md: "6" } },
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addValue()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("add-value")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }